import { base } from "utils/axiosInstances";
import { camelize, snakeify } from "utils/objectUtilities";

const URL = "/user";

export const getUser = async () => {
  try {
    const response = await base.get(URL);
    return camelize(response.data, true);
  } catch (error) {
    const { response } = error;
    throw new Error(response.message, response.status);
  }
};

export const editUser = async (payload) => {
  try {
    const response = await base.put(URL, snakeify(payload));
    return camelize(response.data, true);
  } catch (error) {
    const { response } = error;
    throw new Error(response.message, response.status);
  }
};
